import { render, staticRenderFns } from "./Giveback.vue?vue&type=template&id=33698f4a&"
import script from "./Giveback.vue?vue&type=script&lang=js&"
export * from "./Giveback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports